export const SET_REVIEWS = "SET_REVIEWS";
export const GET_REVIEWS = "GET_REVIEWS";
export const GET_CATEGORY_REVIEWS = "GET_CATEGORY_REVIEWS";
export const SET_CATEGORY_REVIEWS = "SET_CATEGORY_REVIEWS";
export const ADD_REVIEWS = "ADD_REVIEWS";
export const GET_USER_REVIEWS = "GET_USER_REVIEWS";
export const GET_PROFILE_USER_REVIEWS = "GET_PROFILE_USER_REVIEWS";